// extracted by mini-css-extract-plugin
export var childrenContainer = "_d2-0";
export var virtualScrollArea = "_d2-1";